import {
  usePointChangeSleepSettingsMutation,
  PointPureSleepSettingsMutationInput,
} from '@shared/api/graphql/generated';
import { FetchPolicyKeys } from '@shared/api/graphql/types';

const usePointSleepSettings = () => {
  const [mutation, mutationResult] = usePointChangeSleepSettingsMutation({
    fetchPolicy: FetchPolicyKeys.NETWORK_ONLY,
  });

  const request = async (input: PointPureSleepSettingsMutationInput) => {
    const mutationResult = await mutation({ variables: { input } });
    return !!mutationResult.data?.pointPureSleepSettings?.ok;
  };

  return {
    error: mutationResult.error,
    loading: mutationResult.loading,
    called: mutationResult.called,
    request,
  };
};

export default usePointSleepSettings;
